<template>
    <div class="bg-white">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin: 5%">
                            <div class="text-center">
                                <br /><br /><br />
                                <h1 class="custom-text-aladdin text-black poppin-font custom-52px-600">
                                    Welcome to Creative Insights, where <br /> your videos meet the power of <br /> AI-driven analysis.
                                </h1>
                                <p class="custom-16px-400 text-center ml-4 font-color-737373">Our platform evaluates your content to identify strengths and areas for improvement, providing actionable suggestions <br />
                                    to enhance engagement, creativity, and reach. Simply upload your video, and let our advanced tools analyze <br />
                                    performance metrics, audience impact, and content effectiveness. Whether you’re a budding creator or an established </p>
    
                                
                            </div>
    
    
    
                        </div>
                        <br />
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
        <CCol sm="12" class="bg-FAFAFA">
            <CContainer>
                <br /><br />
               <CRow>
                <CCol sm="6">
                    <CRow>
                        <CCol sm="6">
                            <h3 class="custom-24px-500">Rating Video</h3>
                        </CCol>
                        <CCol sm="6">
                            <CButton type="button" class="custom-light-purple-button font-color-8961E4">Previous</CButton>
                        </CCol>
                    </CRow>
                    <CCard class="p-2 mt-3" style="border:none">
                        <CRow>
                            <CCol sm="3">
                                <img src="../assets/img/smallicon/defaultvideo.png" style="max-width:100%"/>
                            </CCol>
                            <CCol sm="9">
                                <h3 class="custom-16px-500 font-color-212529 text-left">New Product 2025.mp4</h3>
                                <CRow>
                                    <CCol sm="6">
                                        <label class="custom-16px-500 font-color-737373">9 MB</label>
                                    </CCol>
                                    <CCol sm="6">
                                        <img src="../assets/img/smallicon/2star.png" style="max-width:100%"/>
                                    </CCol>
                                    <CCol sm="12">
                                   <img src="../assets/img/smallicon/dot.png" height="10px"/>
                                    <span class="custom-12px-500 font-color-808191 ml-3">12nd January 2024</span>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>
                <CCol sm="6">
                    <CRow>
                        <CCol sm="6">
                            <h3 class="custom-24px-500">Rating Video</h3>
                        </CCol>
                        <CCol sm="6">
                            <CButton type="button" class="custom-light-purple-button font-color-8961E4">After</CButton>
                        </CCol>
                    </CRow>
                    <CCard class="p-2 mt-3" style="border:none">
                        <CRow>
                            <CCol sm="3">
                                <img src="../assets/img/smallicon/defaultvideo.png" style="max-width:100%"/>
                            </CCol>
                            <CCol sm="9">
                                <h3 class="custom-16px-500 font-color-212529 text-left">New Product 2025.mp4</h3>
                                <CRow>
                                    <CCol sm="6">
                                        <label class="custom-16px-500 font-color-737373">9 MB</label>
                                    </CCol>
                                    <CCol sm="6">
                                        <img src="../assets/img/smallicon/5star.png" style="max-width:100%"/>
                                    </CCol>
                                    <CCol sm="12">
                                   <img src="../assets/img/smallicon/dot.png" height="10px"/>
                                    <span class="custom-12px-500 font-color-808191 ml-3">12nd January 2024</span>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>
               </CRow>

              
            </CContainer>
        </CCol>
    
     
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout,
        ToggleCard
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,

            Names: "",
            loading: true,


        };
    },
    created() {
        AOS.init();
    },
    mounted() {
        // const isAuth = this.UserAuth();
        // if (isAuth) {
        //     this.GetInfoUser();
        // } else {
        //     this.loading = false; // If not authenticated, immediately set loading to false
   
        // }
    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
        GoToVideo() {
            this.$router.push("InterviewerrVideo");
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("HowItWork");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("HowItWork");
                console.error("Error fetching user info:", error);
            }
        },
    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
</style>